import { CmsConverterService } from '../../../cms/services/cms-converter/cms-converter.service'
import { TrainingCategoriesData } from './index'
import { Injectable } from '@angular/core'
import { CmsComponent } from '@spartacus/core'

@Injectable({ providedIn: 'root' })
export class TrainingCategoriesConverter extends CmsConverterService<TrainingCategoriesData> {

  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      items: formData.items
    }
  }
}
